import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=b6d3c30e&scoped=true"
import script from "./createDialog.vue?vue&type=script&lang=js"
export * from "./createDialog.vue?vue&type=script&lang=js"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=b6d3c30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d3c30e",
  null
  
)

export default component.exports